






















import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import SupplierOrgSelector from '@superUI/Selectors/SupplierOrgSelector'
import OrganizerForm from '@superUI/Forms/OrganizerForm'
import RequestButton from '@components/RequestButton'

settings =
  name: 'OrganizerCreate'
  components: { Back, SuperContainerView, SupplierOrgSelector, OrganizerForm, RequestButton }
  resources:
    newOrganizer:
        resourceName: 'organizer'
        slug: 'organizers/new'
  vue:
    data: ->
      selectedSupplierId: null
      selectedMultiSupplierId: []

    mounted: ->
      @initializeSelectedSupplier()

    computed:
      supplierIsSelected: ->
        return true if @$route.query.supplierId
        @selectedSupplierId || @selectedMultiSupplierId.length

      errors: ->
        @formErrors?.newOrganizer || {}

    methods:
      onSave: (item) -> @$router.push({ name: 'OrganizerShowPage', params: { organizerId: item.id } })

      hiSave: ->
        if @selectedMultiSupplierId.length
          @prime.newOrganizer.supplier_ids = @selectedMultiSupplierId
        else
          @prime.newOrganizer.supplier_id = @selectedSupplierId

        @saveItem('prime.newOrganizer')

      hiBack: ->
        if @selectedSupplierId || @selectedMultiSupplierId.length
          @selectedSubSupplierId = null
          @selectedSupplierId = null
          @selectedMultiSupplierId = []

      hiSupplierSelected: (selectedSupplier) ->
        @selectedSupplierId = selectedSupplier.id

      hiMultiSupplierSelected: (selectedSuppliersList) ->
        @selectedMultiSupplierId = selectedSuppliersList.map((supplier) -> supplier.id)

      initializeSelectedSupplier: ->
        @selectedMultiSupplierId.push @$route.query.supplierId if @$route.query.supplierId?


export default VueOptions.vue settings
